import { render, staticRenderFns } from "./singleCardAccountCheckRecord.vue?vue&type=template&id=10d52a52&scoped=true"
import script from "./singleCardAccountCheckRecord.vue?vue&type=script&lang=ts"
export * from "./singleCardAccountCheckRecord.vue?vue&type=script&lang=ts"
import style0 from "./singleCardAccountCheckRecord.vue?vue&type=style&index=0&id=10d52a52&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d52a52",
  null
  
)

export default component.exports